/** Admin service tokens — CI/CD-scoped bearer credentials for plugin endpoints. */
import { apiDelete, apiGet, apiPost } from '../client.js';
import type { ServiceTokenIssue, ServiceTokenSummary } from '../types.js';

export function listServiceTokens(): Promise<ServiceTokenSummary[]> {
  return apiGet<ServiceTokenSummary[]>('/api/v1/admin/service-tokens');
}

/**
 * `expiresAt` omitted means the platform's configured default, not "never".
 * A token with no deadline can only be created deliberately.
 */
export function issueServiceToken(
  label: string,
  expiresAt?: string,
): Promise<ServiceTokenIssue> {
  return apiPost<ServiceTokenIssue>('/api/v1/admin/service-tokens', {
    label,
    ...(expiresAt ? { expires_at: expiresAt } : {}),
  });
}

export function rotateServiceToken(id: string): Promise<ServiceTokenIssue> {
  return apiPost<ServiceTokenIssue>(`/api/v1/admin/service-tokens/${id}/rotate`, {});
}

export function deleteServiceToken(id: string): Promise<void> {
  return apiDelete<void>(`/api/v1/admin/service-tokens/${id}`);
}
